var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};
var site = site || {};

site.client = site.client || {};
site.direction = site.direction || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, drammingOption) {
    var $template = $('.js-product-full-image-v1', $(this));

    if (!$template.length) {
      return null;
    }
    $template.data('altTextProcessed', false);
    Drupal.behaviors.productFullImageV1.updateImages($template, skuBaseId, drammingOption);
  });
  $(document).on('product:quickshop:available', '.js-quickshop-container', function () {
    var $template = $('.js-product-full-image-v1', $(this));

    if (!$template.length) {
      return null;
    }
    Drupal.behaviors.productFullImageV1.initThumbnailCarousel($template);
  });
  Drupal.behaviors.productFullImageV1 = {
    attach: function (context) {
      if (this.attached) {
        return;
      }
      var self = this;
      var $containers = $('.js-product-full-image-v1', context);

      self.attached = true;
      $containers.each(function () {
        var $container = $(this);

        self.initMainImageCarousel($container);
        self.initThumbnailCarousel($container);

        $(window).on(
          'resize',
          _.debounce(function () {
            self.initMainImageCarousel($container);
            self.initThumbnailCarousel($container);
          }, 100)
        );

        $('.js-trigger-product-fullscreen .js-product-full-image-main-photo', $container)
          .once()
          .click(function (e) {
            e.preventDefault();
            var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
            var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
            var isDesktop = currentBpWidth >= bPportraitUp;

            if (isDesktop) {
              self.initFullScreen($container, $(e.target));
            }
          })
          .on('keydown.fullImage', function (e) {

            if (typeof site.getKeycode !== 'function') {
              return;
            }

            var key = site.getKeycode(e);

            if (key === 13) {
              // Enter
              e.preventDefault();
              self.initFullScreen($container, $(e.target));
            }
          });
      });
    },
    initFullScreen: function ($container, $target) {
      var self = this;
      var $fullscreenClose = $('.js-product-full-image-fullscreen-close', $container);

      // Expand the image container
      $container.addClass('fullscreen-enabled');
      $('body').addClass('fullscreen-enabled');
      // Analytics zoom open event
      var productElem = $container.closest('.js-product-full');

      if (site && site.track) {
        site.track.altImageZoomSelected({
          zoomAction: 'open',
          eventLabel: productElem.length > 0 ? $(productElem[0]).data('product-id') : '',
          imagePlacement: 'spp',
          imageLabel: $target.attr('src') ? Drupal.behaviors.productFullImageV1.fetchImageName($target.attr('src')) : ''
        });
      }
      site.restrict_navigation($container);

      $fullscreenClose.unbind('click').bind('click', function (e) {
        e.preventDefault();
        self.closeFullScreen($container);
      });

      // Close the dropdown options when clicked outside of the container.
      $container.bind('clickoutside.fullImage', function () {
        self.closeFullScreen($container);
      });

      // Key Bindings
      $(window).bind('keydown.fullImage', function (e) {

        if (typeof site.getKeycode !== 'function') {
          return;
        }

        var key = site.getKeycode(e);

        if (open && key === 27) {
          // Esc
          e.preventDefault();
          self.closeFullScreen($container);
        }
      });
    },
    closeFullScreen: function ($container) {
      $container.removeClass('fullscreen-enabled');
      $('body').removeClass('fullscreen-enabled');
      $(window).unbind('keydown.fullImage');
      $container.unbind('clickoutside.fullImage').unbind('keydown.fullImage');
      // Analytics zoom close event
      if (site && site.track) {
        site.track.altImageZoomSelected({
          zoomAction: 'close',
          eventLabel: 'image_zoom_closed'
        });
      }
    },
    initMainImageCarousel: function ($container, index) {
      var $imagesContainer = $('.js-product-full-image-main', $container);
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentBpWidth >= bPportraitUp;

      index = index || 0;
      if (isDesktop) {
        // Unslick the main image carousel
        $('.js-product-full-image-main.slick-initialized', $container).unslick(
          '.js-product-full-image-main'
        );

        return;
      }
      // case for custom slides count and dots for mobile
      var settings = {
        rtl: site.direction.isRTL,
        infinite: true,
        mobileFirst: true,
        arrows: true,
        speed: 300,
        slide: '.js-product-full-image-main-photo, .js-video-block__media',
        initialSlide: index,
        slidesToShow: 1,
        slidesToScroll: 1,
        onAfterChange: function (args) {
          var drupalAnalytics = Drupal.settings.analytics.alt_image_tagging_enabled;

          if (drupalAnalytics) {
            $(document).trigger('SLICKCHANGE');
          }
        }
      };

      // Init this carousel with our settings
      $imagesContainer.not('.slick-initialized').slick(settings);
      $imagesContainer.slickGoTo(index); // hack to set the active image of the slick slider.
    },
    initThumbnailCarousel: function ($container, index) {
      var $mainImages = $(
        '.js-product-full-image-main-photo, .js-product-full-image__photo--main-video',
        $container
      );
      var $thumbsContainer = $('.js-product-full-image-thumbs', $container);
      var $thumbsContent = $('.js-product-full-image-thumbs-content', $container);
      var $thumbsContentInner = $('.js-product-full-image-thumbs-content-inner', $thumbsContent);
      var $thumbnails = $(
        '.js-product-full-image-thumb, .js-product-full-image-thumb-video',
        $container
      );
      var $altCount = $('.js-product__altcount', $container);
      var $thumbBackArrow = $('.js-thumbs-left', $container);
      var $thumbUpArrow = $('.js-thumbs-right', $container);
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentBpWidth >= bPportraitUp;
      var $thumbActive;
      var $downArrow = $('.js-arrow-down', $thumbsContainer).addClass('hidden');
      var $upArrow = $('.js-arrow-up', $thumbsContainer).addClass('hidden');
      var $arrowCarousel = $('.js-alt-main-carousel', $container);
      var thumbLength = $thumbnails.length;

      index = $thumbnails.length > index ? index : 0;
      $thumbActive = $($thumbnails.get(index));

      if (thumbLength < 2) {
        $arrowCarousel.addClass('hidden');
      }
      if (!isDesktop) {
        return;
      }

      $thumbnails.each(function (i) {
        var $thumbnail = $(this);

        $thumbnail.off('click.fullImage').on('click.fullImage', function () {
          // here comes the functionality to display the main image at click on the thumbnail
          var $this = $(this);
          var $mainImage = $($mainImages.get(i));
          var $activeIndex = i + 1;

          $altCount.text($activeIndex + '/' + thumbLength);
          if (i === thumbLength - 1) {
            $thumbUpArrow.addClass('inactive');
            $thumbBackArrow.removeClass('inactive');
          } else if (i === 0) {
            $thumbUpArrow.removeClass('inactive');
            $thumbBackArrow.addClass('inactive');
          } else {
            $thumbBackArrow.add($thumbUpArrow).removeClass('inactive');
          }
          $thumbnails.removeClass('active');
          $this.addClass('active');

          $mainImages.removeClass('active');
          $mainImage.addClass('active');
        });
      });

      var _setArrowState = function (el) {
        var $self = el ? $(el) : $(this);
        var posTop = $self.scrollTop();
        var carouselHeight = $self.height();
        var containerHeight = $thumbsContentInner.height();

        if (containerHeight > carouselHeight) {
          $downArrow.removeClass('hidden');
          $upArrow.removeClass('hidden');
        }
        $upArrow.removeClass('inactive');
        $downArrow.removeClass('inactive');
        if (Math.round(posTop) >= containerHeight - carouselHeight) {
          $downArrow.addClass('inactive');
        } else if (posTop === 0) {
          $upArrow.addClass('inactive');
        }
      };

      // Set the initial state of the arrows.
      _setArrowState($thumbsContent[0]);
      // keep state updated on thumbnail image swap
      $container.on('thumbs-content:updated', function () {
        _setArrowState($thumbsContent[0]);
      });

      $('.js-arrow-up', $thumbsContainer)
        .once()
        .on('click tab', function () {
          var $self = $(this);
          var carouselHeight = $thumbsContent.height();
          var position = $thumbsContent.scrollTop();

          if ($self.hasClass('inactive') || $self.hasClass('animating')) {
            return;
          }
          $self.addClass('animating');
          $thumbsContent.animate(
            {
              scrollTop: position - carouselHeight
            },
            500,
            function () {
              $self.removeClass('animating');
            }
          );
        });
      $('.js-arrow-down', $thumbsContainer)
        .once()
        .on('click tab', function () {
          var $self = $(this);
          var carouselHeight = $thumbsContent.height();
          var position = $thumbsContent.scrollTop();

          if ($self.hasClass('inactive') || $self.hasClass('animating')) {
            return;
          }
          $self.addClass('animating');
          $thumbsContent.animate(
            {
              scrollTop: Math.round(position) + carouselHeight
            },
            500,
            function () {
              $self.removeClass('animating');
            }
          );
        });
      $thumbsContent.once().on(
        'scroll',
        _.debounce(function () {
          _setArrowState(this);
        }, 10)
      );
      // Set active the first image or current
      $thumbActive.trigger('click');
      if (!$thumbActive.is(':visible')) {
        $thumbActive.focus();
      }

      $thumbBackArrow
        .add($thumbUpArrow)
        .once()
        .on('click', function () {
          var $currentImg = $(
            '.js-product-full-image-main-photo.active, .js-product-full-image__photo--main-video.active',
            $container
          );
          var direction = $(this).is($thumbBackArrow) ? 'left' : 'right';

          slideCounter(direction, $currentImg);
        });
      var slideCounter = function (direction, img) {
        var activeImg = direction === 'left' ? img.prev() : img.next();
        var activeImgIndex = activeImg.index();
        var $currentThumbImg = $($thumbnails.get(activeImgIndex));
        var carouselHeight = $thumbsContent.height();
        var activeImgTop = $currentThumbImg.position().top;
        var activeImgHeight = $currentThumbImg.outerHeight(true);
        var activeCarouselHeight = activeImgIndex * activeImgHeight;

        if (activeImgTop >= carouselHeight) {
          $thumbsContent.animate(
            {
              scrollTop: activeCarouselHeight
            },
            500
          );
        } else if (activeImgTop < 0) {
          $thumbsContent.animate(
            {
              scrollTop: activeCarouselHeight - activeImgHeight
            },
            500
          );
        }
        if (activeImg.length) {
          $thumbnails.add(img).removeClass('active');
          $currentThumbImg.add(activeImg).addClass('active');
          $thumbBackArrow.add($thumbUpArrow).removeClass('inactive');
          $altCount.text(activeImgIndex + 1 + '/' + thumbLength);
          if (activeImgIndex === thumbLength - 1 || activeImgIndex === 0) {
            if (direction === 'right') {
              $thumbBackArrow.removeClass('inactive');
              $thumbUpArrow.addClass('inactive');
            } else {
              $thumbBackArrow.addClass('inactive');
              $thumbUpArrow.removeClass('inactive');
            }
          }
        }
      };
    },
    updateImages: function ($container, skuBaseId, drammingOption) {
      var self = this;
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentBpWidth >= bPportraitUp;
      var skuData = prodcat.data.getSku(skuBaseId);
      var productData = prodcat.data.getProduct(skuData.PRODUCT_ID);

      // Unslick the main image carousel
      $('.js-product-full-image-main.slick-initialized', $container).unslick(
        '.js-product-full-image-main'
      );

      // Load the bundle SKU images when page get load first time for dramming product
      if (drammingOption === 'noshade') {
        skuData = page_data['catalog-spp-dramming']['products'][0].defaultSku;
      }
      var $mainImages = $('.js-product-full-image-main-photo', $container);
      var $thumbnails = $('.js-product-full-image-thumb', $container);
      var $imageActive = $('.js-product-full-image-main-photo.slick-active', $container);
      var $videoContainer = $('.js-video-block__media', $container);
      var $videoThumbnailContainer = $('.js-product-full-image-thumb-video', $container);
      var videoExists = productData.VIDEO_SOURCE ? !!productData.VIDEO_SOURCE.length : 0;
      var index = $imageActive.attr('index') || 0;
      var tmbIndex = 0;
      var arrLen = 0;
      var imgLen = 0;
      var len = 0;
      var lastThumb = 0;
      var videoLen = 0;
      var imgVideoLen = 0;
      var $mainImage;
      var $thumbnail;
      var $thumbnailImage = $();
      var $mainImageContainer;
      var $thumbnailsContainer;
      var $thumbnailsWrapper;
      var $videoActive;
      var swapImageField = $mainImages.data('swapImageField') || 'IMAGE_LARGE_COMBINED';
      var isProductImageResponsive =
        Drupal.settings.global_variables &&
        Drupal.settings.global_variables.product_responsive_images;
      var baseImagePath;
      var imageSrcset;
      var siteName = Drupal.settings.common && Drupal.settings.common.site_name + ', ' || '';
      var skuName = skuData.SHADENAME || skuData.PRODUCT_SIZE || '';
      var productName = productData.PROD_RGN_NAME + ', ' || '';
      var imageAltText = siteName + productName + skuName;

      var productFullImageSrcsetSizes = [
        {
          size: '440',
          xDescriptor: '440w',
        },
        {
          size: '768',
          xDescriptor: '768w',
        },
        {
          size: '1200',
          xDescriptor: '1200w',
        },
      ];

      if (!_.isNull(skuData)) {
        if (_.isArray(skuData[swapImageField]) && skuData[swapImageField].length) {
          // Unslick the main image carousel before update the images
          $('.js-product-full-image-main.slick-initialized', $container).unslick(
            '.js-product-full-image-main'
          );
          $mainImages = $('.js-product-full-image-main-photo', $container);

          arrLen = skuData[swapImageField].length;
          imgLen = $mainImages.length;
          videoLen = $videoContainer.length;
          imgVideoLen = imgLen + videoLen;

          len = arrLen > imgLen ? arrLen : imgLen;
          lastThumb = len - 1;
          $mainImageContainer = $('.js-product-full-image-main', $container);
          $thumbnailsContainer = $('.js-product-full-image-thumbs-content-inner', $container);
          $thumbnailsWrapper = $('.js-product-full-image-thumbs', $container);

          if (imgVideoLen > 4) {
            if (!$thumbnailsWrapper.hasClass('product-full-image__thumbs--carousel')) {
              $thumbnailsWrapper.addClass('product-full-image__thumbs--carousel');
            }
          } else {
            $thumbnailsWrapper.removeClass('product-full-image__thumbs--carousel');
          }

          for (var i = 0; i < len; i++) {
            if (imgLen >= i + 1) {
              $mainImage = $($mainImages.get(i));
              $thumbnail = $($thumbnails.get(i));
              $thumbnailImage = $thumbnail.find('img');
            } else {
              if ($mainImages.length > 1) {
                $mainImage = $mainImages.filter(':not(.active)').first().clone();
                $thumbnail = $thumbnails.filter(':not(.active)').first().clone();
              } else {
                $mainImage = $mainImages.first().clone();
                $thumbnail = $thumbnails.first().clone().removeClass('active');
              }
            }

            if ($container.data().altTextProcessed !== true) {
              $mainImage.attr('alt', imageAltText);
              $container.data('altTextProcessed', true);
            }

            // Add attributes for ADA carousel functionality
            if (arrLen > 4) {
              $thumbnail.attr('role', 'tab').data('role-orientation', 'vertical');
            } else {
              $thumbnail.removeAttr('role data-role-orientation');
            }

            if ($thumbnail.hasClass('active')) {
              tmbIndex = i;
            }

            // Remove the extra image objs if the new image array is smaller
            if (arrLen >= i + 1) {
              $mainImage.attr('src', skuData[swapImageField][i]);
              $thumbnail.find('img').attr('src', skuData[swapImageField][i]);
              $mainImageContainer.append($mainImage);
              $thumbnailsContainer.append($thumbnail);

              if (isProductImageResponsive) {
                baseImagePath = skuData[swapImageField][i].split('?')[0];
                imageSrcset = '';
                productFullImageSrcsetSizes.forEach(imageSrcsetSize => {
                  imageSrcset += `${baseImagePath}?width=${imageSrcsetSize.size}&height=${imageSrcsetSize.size} ${imageSrcsetSize.xDescriptor},`;
                });
                imageSrcset = imageSrcset.slice(0, -1);
                $mainImage.attr('srcset', imageSrcset);
              }
            } else {
              $mainImage.remove();
              $thumbnail.remove();
            }
            if (lastThumb === i) {
              $thumbnail.find('img').on('load', function () {
                $container.once().trigger('thumbs-content:updated');
                $(this).off('load');
              });
            }
          }

          // SPP alt video
          if (videoExists) {
            $videoContainer.click(function () {
              $videoActive = $(this);
              self.closeFullScreen($container);
              var opts = {
                openOverlay: true,
                provider: $videoActive.data('video-provider')
              };

              if ($videoActive.data('video-provider') === 'YouTube') {
                opts.youTubeId = $videoActive.data('video-source');
              } else if ($videoActive.data('video-provider') === 'MP4') {
                opts.mp4Source = $videoActive.data('video-source');
              }

              site.videos.open(opts);
            });
            $mainImageContainer.append($videoContainer);
            $thumbnailsContainer.append($videoThumbnailContainer);
          }

          if (index > arrLen) {
            index = arrLen - 1;
          }

          if (tmbIndex + 1 > arrLen) {
            tmbIndex = arrLen - 1;
          }

          if (arrLen !== imgLen) {
            self.initThumbnailCarousel($container, tmbIndex);
          }

          self.initMainImageCarousel($container, index);
        }
      }
    },
    fetchImageName: function (imageUrl) {
      var imageName = '';

      if (imageUrl && imageUrl !== '' && imageUrl.includes('/')) {
        var imageArray = imageUrl.split('/');

        imageName = imageArray[imageArray.length - 1].split('?')[0];
      }

      return imageName;
    },
    attached: false
  };
})(jQuery);
